import { useApiConnectionStatus } from "@/common/hooks/useApiConnectionStatus";
import { useInternetConnectionStatus } from "@/common/hooks/useInternetConnectionStatus";

import { ConnectionStatusIndicator } from "./ConnectionStatusIndicator";

/** Displays status of internet and API connection. */
export function InternetAndApiConnectionStatusIndicator() {
  const internetStatus = useInternetConnectionStatus();
  const apiStatus = useApiConnectionStatus({ withRecurringCheck: true });

  const isConnected = internetStatus.isConnected && apiStatus.isConnected;

  return (
    <ConnectionStatusIndicator
      isConnected={isConnected}
      variant='icon'
      noConnectionTitle={
        (!internetStatus.isConnected && !apiStatus.isConnected) || !internetStatus.isConnected
          ? "No internet connection. Please check your internet connection and refresh the page."
          : "Unable to connect to the server. Please try again later."
      }
    />
  );
}
